/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React from 'react';
import {
  Image,
  ImageSourcePropType,
  Platform,
  ScrollView,
  View,
} from 'react-native';
import {connect} from 'react-redux';
import {addThousandSeparator} from '../../../../../common/utils/functions';
import config from '../../../../../data/config';
import {IValues} from '../../../../../data/types/interface/Assurance/AssuranceRapatriement/souscription';
import {StackParams} from '../../../../../data/types/navigation';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import PrimaryButton from '../../../../components/Button/PrimaryButton';
import {buttonsStyles} from '../../../../components/Button/boutonStyle';
import {BoxShadowed} from '../../../../components/Container/BoxShadowed';
import DisplayImage from '../../../../components/DisplayImage';
import Label from '../../../../components/Label';
import {LinkWithIconDownload} from '../../../../components/Link';
import {styles as resultStyles} from '../../Devis/Demande/styles';
import {styles} from './styles';
const mainTitle = 'RECAPITULATIF';

interface ValidationFormProps {
  onCancel: (afterSave?: boolean) => void;
  onSubmit: (data: any) => void;
  data: any;
  user?: any;
  showError: (errorMessage: string) => void;
  isRenewal?: boolean;
}
type NavigationProps = StackNavigationProp<StackParams, 'Home'>;

const ConfirmationRapatriementFC = ({
  onCancel,
  onSubmit,
  data,
  user,
}: ValidationFormProps) => {
  const [recapData] = React.useState<IValues>({
    ...data,
  });
  const {navigate} = useNavigation<NavigationProps>();

  const handleSubmit = (values: any) => {
    onSubmit(values);
  };
  const currentUser = user?.data?.utilisateur;

  useFocusEffect(() => {
    if (!currentUser) {
      navigate('Login', {
        data: 'SouscriptionAssuranceRapatriement',
        params: {...data},
      });
    }
  });

  return (
    <View style={{flex: 1}}>
      <View style={{marginBottom: 20, paddingHorizontal: 20}}>
        <Label title={mainTitle} type="mainTitle" />
      </View>

      <ScrollView style={{paddingHorizontal: 10}}>
        <BoxShadowed>
          <Label title="Résumé de votre assurance" />
        </BoxShadowed>

        {recapData.assure.length
          ? recapData.assure.map(currentAssured => (
              <BoxShadowed
                key={`list_assured_recap_${currentAssured.id}`}
                style={
                  Platform.OS === 'web'
                    ? {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                      }
                    : {}
                }>
                <View>
                  <Label
                    title="Bénéficiaire"
                    type="mainTitle"
                    textStyle={{textTransform: 'uppercase', marginTop: 0}}
                  />
                  <View>
                    <Label title={'Nom :'} type="titleGreen14" />
                    <Label title={currentAssured.nom} />
                  </View>
                  <View>
                    <Label title={'Prénom :'} type="titleGreen14" />
                    <Label title={currentAssured.prenom} />
                  </View>
                  <View>
                    <Label title={'Date de naissance :'} type="titleGreen14" />
                    <Label
                      title={dayjs(currentAssured.dateNaissance).format(
                        'DD/MM/YYYY',
                      )}
                    />
                  </View>
                  <View>
                    <Label
                      title={"Numéro de carte d'identité / de séjour :"}
                      type="titleGreen14"
                    />
                    <Label title={currentAssured.numCI} />
                  </View>
                </View>
                <View style={{maxWidth: '100%'}}>
                  {currentAssured.newImage ? (
                    typeof currentAssured.capture_file == 'string' ? (
                      <DisplayImage
                        url={`repatrius/files/content/${currentAssured.capture_file}`}
                        style={
                          Platform.OS === 'web'
                            ? {
                                width: 400,
                                maxWidth: '100%',
                                height: 250,
                                resizeMode: 'contain',
                              }
                            : {
                                width: '100%',
                                height: 250,
                                resizeMode: 'contain',
                              }
                        }
                      />
                    ) : (
                      <Image
                        source={
                          (Platform.OS == 'web'
                            ? URL.createObjectURL(
                                currentAssured.capture_file[0],
                              )
                            : {
                                uri: currentAssured.capture_file[0].uri,
                              }) as ImageSourcePropType
                        }
                        style={
                          Platform.OS === 'web'
                            ? {
                                width: 400,

                                maxWidth: '100%',
                                height: 250,
                                resizeMode: 'contain',
                              }
                            : {
                                width: '100%',
                                height: 250,
                                resizeMode: 'contain',
                              }
                        }
                      />
                    )
                  ) : (
                    <DisplayImage
                      url={`repatrius/files/content/${currentAssured.lastCaptureFile}`}
                      style={
                        Platform.OS === 'web'
                          ? {
                              width: 400,
                              maxWidth: '100%',
                              height: 250,
                              resizeMode: 'contain',
                            }
                          : {width: '100%', height: 250, resizeMode: 'contain'}
                      }
                    />
                  )}
                </View>
              </BoxShadowed>
            ))
          : null}

        <BoxShadowed>
          <Label
            title="Souscripteur"
            type="mainTitle"
            textStyle={{textTransform: 'uppercase', marginTop: 0}}
          />
          <View>
            <Label title={'Nom :'} type="titleGreen14" />
            <Label title={currentUser?.nom} />
          </View>
          <View>
            <Label title={'Prénom :'} type="titleGreen14" />
            <Label title={currentUser?.prenom} />
          </View>
          <View>
            <Label title={'Email'} type="titleGreen14" />
            <Label title={currentUser?.email} />
          </View>
        </BoxShadowed>

        <View style={{height: 50}} />
        {recapData.devis && (
          <View>
            <View style={[resultStyles.flex, resultStyles.priceContainer]}>
              <Label
                title={`Prime TTC en Ariary: `}
                type="mainTitle"
                textStyle={resultStyles.noMargin}
              />
              <Label
                title={`${addThousandSeparator(
                  Math.ceil(
                    recapData.devis.tarificationTotale.primeTtcTotaleMGA,
                  ),
                )} Ar`}
                type="mainTitle"
                textStyle={resultStyles.noMargin}
              />
            </View>

            <View style={[resultStyles.flex, resultStyles.priceContainer]}>
              <Label
                title={`Prime TTC en Euro: `}
                type="mainTitle"
                textStyle={resultStyles.noMargin}
              />
              <Label
                title={`${addThousandSeparator(
                  Math.ceil(
                    recapData.devis.tarificationTotale.primeTtcTotaleEUR,
                  ),
                )} €`}
                type="mainTitle"
                textStyle={resultStyles.noMargin}
              />
            </View>
          </View>
        )}
        <View style={{paddingHorizontal: 10}}>
          <LinkWithIconDownload
            text="Notice d'information.pdf"
            url={config.noticeRapatriement}
          />
        </View>

        <View style={[styles.buttonContainer]}>
          <>
            <PrimaryButton
              onPress={() => onCancel()}
              styleBtnTxt={buttonsStyles.btnAnnuler}
              styleBtnOuter={[
                buttonsStyles.btnAnnulerOuterSimu,
                {maxWidth: 200},
              ]}
              styleContainer={{alignItems: 'center'}}
              title="Annuler"
              type="annuler"
            />

            <PrimaryButton
              onPress={() => handleSubmit(recapData)}
              styleBtnTxt={[styles.buttonText]}
              styleBtnOuter={[styles.buttonOuter, {maxWidth: 200}]}
              title={'Souscrire'}
              type="valider"
              isDisable={!Boolean(data)}
              styleContainer={{alignItems: 'center'}}
            />
          </>
        </View>
      </ScrollView>
    </View>
  );
};

export const ConfirmationRapatriement = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmationRapatriementFC);
